// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.coins=VITE_RPC_COINS_URL,include.creativefabrica.coins.v2.CoinsService.GetPricing=query,include.creativefabrica.coins.v2.CoinsService.GetBalance=query,include.creativefabrica.coins.v2.CoinsService.ListUserTransactionStats=query,include.creativefabrica.coins.v2.CoinsService.GetTeamSettings=query,include.creativefabrica.coins.v2.CoinsService.GetAutoTopUpSettings=query,include.creativefabrica.coins.v2.CoinsService.UpdateAutoTopUpSettings=mutation"
// @generated from file creativefabrica/coins/v2/service.proto (package creativefabrica.coins.v2, syntax proto3)
/* eslint-disable */

import type { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { CoinsService, GetPricingResponse, GetPricingRequestSchema, GetBalanceResponse, GetBalanceRequestSchema, GetAutoTopUpSettingsResponse, GetAutoTopUpSettingsRequestSchema, UpdateAutoTopUpSettingsResponse, UpdateAutoTopUpSettingsRequestSchema, GetTeamSettingsResponse, GetTeamSettingsRequestSchema, ListUserTransactionStatsResponse, ListUserTransactionStatsRequestSchema } from "./service_pb";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the CoinsService service
 * Service: creativefabrica.coins.v2.CoinsService
 */

let CoinsServiceClient: ReturnType<typeof createClient<typeof CoinsService>> | undefined

function getCoinsServiceClient() {
  const baseUrl = process.env.VITE_RPC_COINS_URL
  invariant(baseUrl, 'VITE_RPC_COINS_URL env var is not set')
  CoinsServiceClient ??= createClient(
    CoinsService,
    createConnectTransport({
      baseUrl,
      useBinaryFormat: false,
      interceptors,
    }),
  )
  return CoinsServiceClient
}

/**
 * Unique identifier for the GetPricing query
 */
export const GetPricingQueryRootKey = 'CoinsService.GetPricing' as const;

/**
 * Return type for the GetPricing query
 */
type GetPricingQueryResult = GetPricingResponse;

/**
 * Generates a unique query key for the GetPricing query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetPricingQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getPricingQueryKey = /*@__PURE__*/ function getPricingQueryKey(variables?: MessageInitShape<typeof GetPricingRequestSchema>): QueryKey<MessageInitShape<typeof GetPricingRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetPricingRequestSchema>> = [GetPricingQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * GetPricing returns static coin pricing for a single action or every
 * known action. Replaces the GetConfig spend-action breakdown for v2
 * clients. Surface-specific variants (e.g. Lumo) are encoded as distinct
 * PricingAction enum values.
 *
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetPricing
 */
/**
 * Function to execute the GetPricing RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getPricingFn(variables: MessageInitShape<typeof GetPricingRequestSchema>, meta?: Record<string, unknown>): Promise<GetPricingResponse> {
  return getCoinsServiceClient().getPricing(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetPricing query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getPricingQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetPricingQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getPricingQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetPricingRequestSchema>): QueryOptions<GetPricingQueryResult, MessageInitShape<typeof GetPricingRequestSchema>> {
  return {
    queryKey: getPricingQueryKey(variables),
    queryFn: async (context) => getPricingFn(variables, context.meta)
  };
};


/**
 * GetPricing returns static coin pricing for a single action or every
 * known action. Replaces the GetConfig spend-action breakdown for v2
 * clients. Surface-specific variants (e.g. Lumo) are encoded as distinct
 * PricingAction enum values.
 *
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetPricing
 */
export function useGetPricingQuery<D = GetPricingQueryResult, E = Error>(variables: MessageInitShape<typeof GetPricingRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetPricingQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetPricingRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetPricingQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetPricingRequestSchema>>
  >({
    ...options,
    ...getPricingQueryOptions(variables),
  });
}

/**
 * Unique identifier for the GetBalance query
 */
export const GetBalanceQueryRootKey = 'CoinsService.GetBalance' as const;

/**
 * Return type for the GetBalance query
 */
type GetBalanceQueryResult = GetBalanceResponse;

/**
 * Generates a unique query key for the GetBalance query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetBalanceQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getBalanceQueryKey = /*@__PURE__*/ function getBalanceQueryKey(variables?: MessageInitShape<typeof GetBalanceRequestSchema>): QueryKey<MessageInitShape<typeof GetBalanceRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetBalanceRequestSchema>> = [GetBalanceQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetBalance
 */
/**
 * Function to execute the GetBalance RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Optional input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getBalanceFn(variables?: MessageInitShape<typeof GetBalanceRequestSchema>, meta?: Record<string, unknown>): Promise<GetBalanceResponse> {
  return getCoinsServiceClient().getBalance(variables ?? {}, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetBalance query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getBalanceQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetBalanceQuery hook directly instead.
 * 
 * @param variables - Optional input parameters for the RPC call
 */
export const getBalanceQueryOptions = /*@__PURE__*/ function(variables?: MessageInitShape<typeof GetBalanceRequestSchema>): QueryOptions<GetBalanceQueryResult, MessageInitShape<typeof GetBalanceRequestSchema>> {
  return {
    queryKey: getBalanceQueryKey(variables),
    queryFn: async (context) => getBalanceFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetBalance
 */
export function useGetBalanceQuery<D = GetBalanceQueryResult, E = Error>(variables?: MessageInitShape<typeof GetBalanceRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetBalanceQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetBalanceRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetBalanceQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetBalanceRequestSchema>>
  >({
    ...options,
    ...getBalanceQueryOptions(variables),
  });
}

/**
 * Unique identifier for the GetAutoTopUpSettings query
 */
export const GetAutoTopUpSettingsQueryRootKey = 'CoinsService.GetAutoTopUpSettings' as const;

/**
 * Return type for the GetAutoTopUpSettings query
 */
type GetAutoTopUpSettingsQueryResult = GetAutoTopUpSettingsResponse;

/**
 * Generates a unique query key for the GetAutoTopUpSettings query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetAutoTopUpSettingsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getAutoTopUpSettingsQueryKey = /*@__PURE__*/ function getAutoTopUpSettingsQueryKey(variables?: MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>): QueryKey<MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>> = [GetAutoTopUpSettingsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetAutoTopUpSettings
 */
/**
 * Function to execute the GetAutoTopUpSettings RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getAutoTopUpSettingsFn(variables: MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>, meta?: Record<string, unknown>): Promise<GetAutoTopUpSettingsResponse> {
  return getCoinsServiceClient().getAutoTopUpSettings(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetAutoTopUpSettings query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getAutoTopUpSettingsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetAutoTopUpSettingsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getAutoTopUpSettingsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>): QueryOptions<GetAutoTopUpSettingsQueryResult, MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>> {
  return {
    queryKey: getAutoTopUpSettingsQueryKey(variables),
    queryFn: async (context) => getAutoTopUpSettingsFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetAutoTopUpSettings
 */
export function useGetAutoTopUpSettingsQuery<D = GetAutoTopUpSettingsQueryResult, E = Error>(variables: MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetAutoTopUpSettingsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetAutoTopUpSettingsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetAutoTopUpSettingsRequestSchema>>
  >({
    ...options,
    ...getAutoTopUpSettingsQueryOptions(variables),
  });
}

/**
 * Unique identifier for the UpdateAutoTopUpSettings mutation
 */
export const UpdateAutoTopUpSettingsMutationKey = 'CoinsService.UpdateAutoTopUpSettings' as const;

/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateAutoTopUpSettings
 */
/**
 * Function to execute the UpdateAutoTopUpSettings RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function updateAutoTopUpSettingsFn(variables: MessageInitShape<typeof UpdateAutoTopUpSettingsRequestSchema>, meta?: Record<string, unknown>): Promise<UpdateAutoTopUpSettingsResponse> {
  return getCoinsServiceClient().updateAutoTopUpSettings(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateAutoTopUpSettings
 */
export function useUpdateAutoTopUpSettingsMutation(options?: Omit<
  UseMutationOptions<
    UpdateAutoTopUpSettingsResponse,
    Error,
    MessageInitShape<typeof UpdateAutoTopUpSettingsRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    UpdateAutoTopUpSettingsResponse,
    Error,
    MessageInitShape<typeof UpdateAutoTopUpSettingsRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => updateAutoTopUpSettingsFn(variables, options?.meta),
    mutationKey: [UpdateAutoTopUpSettingsMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the GetTeamSettings query
 */
export const GetTeamSettingsQueryRootKey = 'CoinsService.GetTeamSettings' as const;

/**
 * Return type for the GetTeamSettings query
 */
type GetTeamSettingsQueryResult = GetTeamSettingsResponse;

/**
 * Generates a unique query key for the GetTeamSettings query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetTeamSettingsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getTeamSettingsQueryKey = /*@__PURE__*/ function getTeamSettingsQueryKey(variables?: MessageInitShape<typeof GetTeamSettingsRequestSchema>): QueryKey<MessageInitShape<typeof GetTeamSettingsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetTeamSettingsRequestSchema>> = [GetTeamSettingsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamSettings
 */
/**
 * Function to execute the GetTeamSettings RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getTeamSettingsFn(variables: MessageInitShape<typeof GetTeamSettingsRequestSchema>, meta?: Record<string, unknown>): Promise<GetTeamSettingsResponse> {
  return getCoinsServiceClient().getTeamSettings(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetTeamSettings query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getTeamSettingsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetTeamSettingsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getTeamSettingsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetTeamSettingsRequestSchema>): QueryOptions<GetTeamSettingsQueryResult, MessageInitShape<typeof GetTeamSettingsRequestSchema>> {
  return {
    queryKey: getTeamSettingsQueryKey(variables),
    queryFn: async (context) => getTeamSettingsFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamSettings
 */
export function useGetTeamSettingsQuery<D = GetTeamSettingsQueryResult, E = Error>(variables: MessageInitShape<typeof GetTeamSettingsRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetTeamSettingsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetTeamSettingsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetTeamSettingsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetTeamSettingsRequestSchema>>
  >({
    ...options,
    ...getTeamSettingsQueryOptions(variables),
  });
}

/**
 * Unique identifier for the ListUserTransactionStats query
 */
export const ListUserTransactionStatsQueryRootKey = 'CoinsService.ListUserTransactionStats' as const;

/**
 * Return type for the ListUserTransactionStats query
 */
type ListUserTransactionStatsQueryResult = ListUserTransactionStatsResponse;

/**
 * Generates a unique query key for the ListUserTransactionStats query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListUserTransactionStatsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listUserTransactionStatsQueryKey = /*@__PURE__*/ function listUserTransactionStatsQueryKey(variables?: MessageInitShape<typeof ListUserTransactionStatsRequestSchema>): QueryKey<MessageInitShape<typeof ListUserTransactionStatsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListUserTransactionStatsRequestSchema>> = [ListUserTransactionStatsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.ListUserTransactionStats
 */
/**
 * Function to execute the ListUserTransactionStats RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listUserTransactionStatsFn(variables: MessageInitShape<typeof ListUserTransactionStatsRequestSchema>, meta?: Record<string, unknown>): Promise<ListUserTransactionStatsResponse> {
  return getCoinsServiceClient().listUserTransactionStats(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListUserTransactionStats query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listUserTransactionStatsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListUserTransactionStatsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listUserTransactionStatsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListUserTransactionStatsRequestSchema>): QueryOptions<ListUserTransactionStatsQueryResult, MessageInitShape<typeof ListUserTransactionStatsRequestSchema>> {
  return {
    queryKey: listUserTransactionStatsQueryKey(variables),
    queryFn: async (context) => listUserTransactionStatsFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.coins.v2.CoinsService.ListUserTransactionStats
 */
export function useListUserTransactionStatsQuery<D = ListUserTransactionStatsQueryResult, E = Error>(variables: MessageInitShape<typeof ListUserTransactionStatsRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListUserTransactionStatsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListUserTransactionStatsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListUserTransactionStatsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListUserTransactionStatsRequestSchema>>
  >({
    ...options,
    ...listUserTransactionStatsQueryOptions(variables),
  });
}


